import { useCoreStore } from '@/stores/coreStore'
import { buildSymbol } from '@/utils/quoteHelpers'
import type { MarketType } from '@/utils/types'
import { getBuyMarketType } from '@/utils'
import { computed, type ComputedRef, type Ref } from 'vue'

export type PositionSide = 'long' | 'short' | null | undefined

export const useCexPositionsSide = (
  cex: ComputedRef<string | null>,
  asset: ComputedRef<string | null>,
  marketType: ComputedRef<MarketType>,
  enabledProfiles: Ref<number[]>,
  quote: string = 'USDT',
) => {
  const coreStore = useCoreStore()

  const resolvedMarketType = computed(() => getBuyMarketType(marketType.value))
  const symbol = computed(() =>
    buildSymbol(asset.value || '', quote, resolvedMarketType.value),
  )

  const positionsSide = computed(() => {
    const totalP = [] as PositionSide[]
    enabledProfiles.value.forEach((userProfile) => {
      if (!coreStore.positions[userProfile]) {
        return
      }

      const poz = coreStore.positions[userProfile][cex.value as string]
      if (poz) {
        const openPositions = poz.filter(
          // eslint-disable-next-line
          (x: any) => x['symbol'] == symbol.value,
        )

        openPositions
          .map((x: any) => x['side'] as PositionSide)
          .forEach((z: PositionSide) => {
            totalP.push(z)
          })
      }
    })
    if (totalP.length == 0) {
      return null
    }

    const areEq = totalP.every((val) => val === totalP[0])
    if (!areEq) {
      return null
    }

    return totalP[0]
  })

  return {
    positionsSide,
  }
}
